import { useContext, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { SvgIcon } from '@mui/material';
import { AlertTriangle } from '../../assets';
import { useTranslation } from 'react-i18next';
import { UserContext } from './useUser';
import { ConfirmationDialog } from './dialogs/ConfirmationDialog';

const IdleTimer = () => {
  const { t } = useTranslation('common');
  const [isIdle, setIsIdle] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15);
  const { forceLogout } = useContext(UserContext);

  useEffect(() => {
    if (!isIdle) return;

    if (isIdle && timeLeft === 0) {
      setIsDialogOpen(false);
      setIsIdle(false);
      setTimeLeft(15); // Reset countdown interval
      forceLogout();
    }

    if (!isDialogOpen) {
      setIsDialogOpen(true);
    }

    // Set up an interval to decrease the timer by 1 every second
    const countdownInterval = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(countdownInterval);
  }, [isIdle, timeLeft]);

  const handleOnStay = () => {
    setIsDialogOpen(false);
    setIsIdle(false);
    setTimeLeft(15); // Reset countdown interval
  };

  const handleOnIdle = () => {
    setIsIdle(true);
  };

  useIdleTimer({
    timeout: 1000 * 60 * 15, // 15 minutes in milliseconds
    onIdle: handleOnIdle,
    debounce: 250,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
  });

  return <ConfirmationDialog open={isDialogOpen}
    icon={<SvgIcon sx={{ width: '20px' }}>
      <AlertTriangle />
    </SvgIcon>}
    title={t('iddleStateTitle')}
    message={t('iddleStateMessage', { timeLeft })}
    confirmButtonText={''}
    cancelButtonText={t('stay')}
    onConfirm={() => { }}
    onCancel={handleOnStay}
    showConfirm={false} />;

};

export default IdleTimer;